import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { Grid, Box, Typography } from '@material-ui/core';
import { FormTextInput, FormContainer, Button } from '../../_common';

import { useFormUpdate, useVhListener } from '../../../hooks';
import { Context as AuthContext } from '../../../context/AuthContext';
import { Context as ViewsContext } from '../../../context/ViewsContext';

import Logo from '../../../assets/logo_jamii_2.svg';
import useStyles from './styles';
import useSchemas from './form.schema';

const LoginForm = ({ history }) => {
  const [{ vhUpdated }] = useVhListener();
  const { lRoot, lFormWrapper, logoClass, submitWrapper, link } = useStyles({
    vhUpdated,
  });
  const { initialState, validationStateSchema } = useSchemas();

  const {
    state: { errorMessage },
    signin,
  } = useContext(AuthContext);

  const { setView } = useContext(ViewsContext);

  const [
    updatedData,
    handleUpdateData,
    buttonState,
    handleOnSubmit,
    isButtonLoading,
  ] = useFormUpdate(initialState, validationStateSchema, (cleanData) =>
    handleSubmit(cleanData)
  );

  const handleSubmit = async (cleanData) => {
    try {
      setView(0);
      await signin(cleanData);
      throw Error('Error sends to previous error block.');
    } catch {
      throw Error('Error sends to previous error block.');
    }
  };

  return (
    <Grid container item className={lRoot} wrap="nowrap">
      <img src={Logo} alt="jamii-logo" className={logoClass} />
      <Grid item className={lFormWrapper}>
        <FormContainer errorMessage={errorMessage.message}>
          <FormTextInput
            name="email"
            placeholder="correo"
            value={updatedData.email.value}
            errorValue={updatedData.email.error}
            onChange={handleUpdateData}
            type="email"
          />
          <FormTextInput
            name="password"
            placeholder="contraseña"
            value={updatedData.password.value}
            errorValue={updatedData.password.error}
            onChange={handleUpdateData}
            type="password"
          />
          <Box className={submitWrapper}>
            <Button
              handleClick={handleOnSubmit}
              disabled={!buttonState}
              isLoading={isButtonLoading}
            >
              Entrar
            </Button>
            <a
              className={link}
              href="https://www.jamii.mx"
              target="_blank"
              rel="noopener noreferrer"
            >
              ¿Aún no eres miembro?
            </a>
          </Box>
        </FormContainer>
        <Box width="100%" textAlign="center">
          <Typography
            className={link}
            style={{ fontSize: 12 }}
            onClick={() => history.push('/password-recovery')}
          >
            ¿Olvidaste tu contraseña?
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default withRouter(LoginForm);
